import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "folder-navigator-component" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["data-key"]
const _hoisted_4 = ["onClick", "href"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["onClick", "href"]

import labels from "../../../../shared/labels";
import Filler from "../../../../shared/Filler.vue";
import { type PropType, type Ref, computed, ref } from "vue";
import { type MappedProductCollectionModel } from "../../models";
import FadeAndSlide from "../../../../shared/FadeAndSlide.vue";
import {
    flattenAllCollectionsWithDepth,
    flattenAllCollectionsWithParents,
} from "../../collection-methods";
import { getCollectionUrl } from "../../collection-url";
import SubItems from "./sub-items.vue";
import CheckboxItem from "../common/checkbox-item.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'list',
  props: {
    siteGuid: Number,
    productListGuid: Number,
    value: Array as PropType<number[][]>,
    root: Array as PropType<MappedProductCollectionModel[]>,
    scopedRoot: Object as PropType<MappedProductCollectionModel>,
    forceBackArrow: Boolean,
    baseUrl: String,
    getVisible: {
        type: Function,
        required: true,
    },
    viewMode: {
        type: Number,
        required: true,
    },
    // findCollectionById: {
    //     type: Function as PropType<
    //         (
    //             collectionId: number,
    //             mappedRoot: ProductCollectionModel[] | MappedProductCollectionModel[] | undefined
    //         ) => ProductCollectionModel
    //     >,
    //     required: true,
    // },
    // getFlattenedCollections: {
    //     type: Function as PropType<
    //         (
    //             collections: ProductCollectionModel[]
    //         ) => Generator<ProductCollectionModel>
    //     >,
    //     required: true,
    // },
    matchedLogicalName: String,
    matchedLogicalNameEntityGuid: Number,
    matchedLogicalNameModuleGuid: Number,
    matchedLogicalNameSubModuleGuid: Number,
},
  emits: [
    "emit-value",
    "navigate-to-collection",
    "update-product-count",
],
  setup(__props, { emit: __emit }) {

const debugProductCounts = ((window as any).debugProductCounts ??
    (((window as any).debugProductCounts = ref(false)) as Ref<boolean>)) as
    | boolean
    | Ref<boolean>;

const props = __props;

// const collectionsOwner = computed(() => {
//     if (props.root == null) return null;
//     if (props.scopedRoot == null) return null;
//     const selectedCol = props.scopedRoot;

//     let collection: MappedProductCollectionModel | null | undefined = null;
//     if (selectedCol != null) {
//         collection = selectedCol;
//         if (
//             !Array.isArray(collection.SubCollections) ||
//             collection.SubCollections.length <= 0
//         )
//             collection = collection.parent;
//     }

//     if (collection === props.scopedRoot) collection = null;

//     return collection;
// });
const mappedRoot = computed(() => {
    if (props.root == null) return props.root;
    if (props.scopedRoot != null) {
        return props.scopedRoot.SubCollections;
    }
    return props.root;
});
const collections = computed(() => {
    if (props.root == null)
        return typeof props.root === "undefined" ? undefined : null;
    return mappedRoot.value;
});
const selectedItems = computed(() => {
    const result = [];
    if (collections.value != null) {
        for (const collection of collections.value) {
            if (props.getVisible(collection)) {
                for (const {
                    subCollection,
                } of getFlattenedCollectionsArrayWithCount(
                    collection.SubCollections
                )) {
                    if (
                        isChecked(
                            props.value,
                            collections.value.indexOf(collection),
                            subCollection.Id
                        )
                    ) {
                        result.push({ collection, subCollection });
                    }
                }
            }
        }
    }
    return result;
});

// onMounted(() => {
//     console.debug(mappedRoot.value);
// });

const emit = __emit;

function getName(col: MappedProductCollectionModel) {
    if (col.Filler) return undefined;
    let name = col.Name;

    if (
        debugProductCounts == true ||
        (typeof debugProductCounts !== "boolean" && debugProductCounts.value)
    ) {
        name += ` ${col.ProductCount}`;
    }
    return name;
}

function isChecked(
    value: number[][] | undefined | null,
    index: number,
    collectionId: number
) {
    if (value == null) return false;
    const group = value[index];
    if (group == null) return false;
    if (group.length == 0) return false;
    return group.includes(collectionId);
}
function setChecked(
    index: number,
    collectionId: number,
    checked: boolean | undefined | null = null,
    depth?: number | undefined
) {
    //console.debug("setChecked",index,collectionId,checked,depth);
    if (index < 0) throw new Error(`trying to set checked on index ${index}`);
    if (checked == null) checked = !isChecked(props.value, index, collectionId);
    // console.debug("SET CHECKED", index, collectionId, checked);
    const checkedValues = props.value == null ? [] : props.value.concat();
    while (checkedValues.length < index + 1) {
        checkedValues.push([]);
    }
    const group = checkedValues[index];

    if (checked) {
        group.push(collectionId);
    } else {
        while (group.includes(collectionId)) {
            const index = group.indexOf(collectionId);
            group.splice(index, 1);
        }
    }

    if (checked && depth != null && depth > 0) {
        const flatCol = Array.from(
            flattenAllCollectionsWithParents(
                props.scopedRoot?.SubCollections ??
                    ([] as MappedProductCollectionModel[])
            )
        );
        const col = flatCol.find((x) => x.collection.Id == collectionId);
        if (col != null) {
            const parent = col.parents[col.parents.length - 1];

            if (parent != null) {
                while (group.includes(parent.Id)) {
                    const index = group.indexOf(parent.Id);
                    group.splice(index, 1);
                }
            }
        }
    }

    emit("emit-value", checkedValues);
    emit("update-product-count");
}

function getFlattenedCollectionsArrayWithCount(
    collections: MappedProductCollectionModel[]
): { subCollection: MappedProductCollectionModel; i: number; depth: number }[] {
    if (collections == null || collections.length == 0) return [];
    let items = Array.from(flattenAllCollectionsWithDepth(collections));
    if (items.some((x) => x.collection.hasOwnProperty("ProductCount"))) {
        items = items.sort((a, b) => {
            // if (a.collection.parent != null && b.collection.parent != null) {
            //     if (a.collection.parent.Id != b.collection.parent.Id) {
            //         return (
            //             (b.collection.parent.ProductCount ?? 0) -
            //             (a.collection.parent.ProductCount ?? 0)
            //         );
            //     }
            // }
            return (
                (b.collection.ProductCount ?? 0) -
                (a.collection.ProductCount ?? 0)
            );
        });
        const lowestDepth = items
            .concat()
            .sort((a, b) => a.depth - b.depth)[0].depth;

        let somethingChanged = true;
        while (somethingChanged) {
            somethingChanged = false;
            const itemsCopy = items.concat();
            for (const item of itemsCopy) {
                if (item.collection.parent == null) continue;
                if (item.depth == lowestDepth) continue;
                const parent = item.collection.parent;
                const itemMatchParent = items.find(
                    (x) => x.collection.Id == parent.Id
                );
                if (itemMatchParent == null) continue;

                const reversedItems = items.concat().reverse();
                const reversedIndex = reversedItems.indexOf(item);
                const parentAbove = reversedItems.find(
                    (x, i) => i > reversedIndex && x.depth < item.depth
                );

                if (parentAbove?.collection.Id == item.collection.parent.Id)
                    continue;

                somethingChanged = true;
                const index = items.indexOf(itemMatchParent);
                items.splice(items.indexOf(item), 1);
                items.splice(index + 1, 0, item);
            }
        }
        items = items
            .reduce(
                (prev, curr) => {
                    const key = curr.depth;
                    if (prev.length === 0 || prev[prev.length - 1].key != key) {
                        prev.push({ items: [], key: key });
                    }
                    prev[prev.length - 1].items.push(curr);
                    return prev;
                },
                [] as {
                    items: {
                        collection: MappedProductCollectionModel;
                        depth: number;
                    }[];
                    key: number;
                }[]
            )
            .map((x) =>
                x.items.sort(
                    (a, b) =>
                        (b.collection.ProductCount ?? 0) -
                        (a.collection.ProductCount ?? 0)
                )
            )
            .flatMap((x) => x);
    }
    return items.map((item, i) => ({
        subCollection: item.collection,
        i,
        depth: item.depth,
    }));
}

function getDepth(col: MappedProductCollectionModel) {
    let depth = 0;
    while (col.parent != null) {
        depth++;
        col = col.parent;
    }
    return depth;
}

(window as any).testShowAllCollections = function () {
    getFlattenedCollectionsArrayWithCount(mappedRoot.value ?? []).forEach(
        (x) => {
            x.subCollection.Visible = true;
            x.subCollection.ProductCount = 100 * Math.random();
        }
    );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(FadeAndSlide, null, {
      default: _withCtx(() => [
        (__props.forceBackArrow && __props.scopedRoot != null)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([_ctx.$style['main-item'], _ctx.$style['parent-item']])
            }, [
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (
                        _ctx.$emit('navigate-to-collection', __props.scopedRoot.parent)
                    ), ["prevent"])),
                href: 
                        __props.scopedRoot.parent != null
                            ? _unref(getCollectionUrl)(
                                  __props.scopedRoot.parent,
                                  __props.viewMode,
                                  __props.baseUrl,
                                  __props.value,
                                  __props.root ?? [],
                                  __props.matchedLogicalName,
                                  __props.matchedLogicalNameEntityGuid,
                                  __props.matchedLogicalNameModuleGuid,
                                  __props.matchedLogicalNameSubModuleGuid
                              ) ?? '#'
                            : '#'
                    
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.$style['back-arrow'])
                }, null, 2 /* CLASS */)
              ], 8 /* PROPS */, _hoisted_2),
              _createTextVNode(" " + _toDisplayString(__props.scopedRoot.Name), 1 /* TEXT */)
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true)
      ], undefined, true),
      _: 1 /* STABLE */
    }),
    (collections.value != null && selectedItems.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([_ctx.$style['selected-items']])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.$style['selected-items-header']])
          }, _toDisplayString(_unref(labels).get(
                        "frontendProductList.filters.productCollection.resetFilters"
                    )), 3 /* TEXT, CLASS */),
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.$style['selected-items-list']])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedItems.value, ({ collection, subCollection }) => {
              return (_openBlock(), _createElementBlock("div", {
                key: subCollection.Id,
                class: _normalizeClass(_ctx.$style['selected-item']),
                "data-key": subCollection.Id
              }, [
                _createElementVNode("a", {
                  onClick: _withModifiers(($event: any) => (
                                setChecked(
                                    collections.value.indexOf(collection),
                                    subCollection.Id
                                )
                            ), ["prevent"]),
                  href: 
                                subCollection.Filler === true
                                    ? '#'
                                    : _unref(getCollectionUrl)(
                                          subCollection,
                                          __props.viewMode,
                                          __props.baseUrl,
                                          __props.value,
                                          __props.root ?? [],
                                          __props.matchedLogicalName,
                                          __props.matchedLogicalNameEntityGuid,
                                          __props.matchedLogicalNameModuleGuid,
                                          __props.matchedLogicalNameSubModuleGuid
                                      ) ?? '#'
                            
                }, [
                  (subCollection.Filler === true)
                    ? (_openBlock(), _createBlock(Filler, {
                        key: 0,
                        max: 14
                      }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(subCollection.Name), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */)),
                  _cache[1] || (_cache[1] = _createTextVNode(" ")),
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.$style['remove-selected'])
                  }, "✕", 2 /* CLASS */)
                ], 8 /* PROPS */, _hoisted_4)
              ], 10 /* CLASS, PROPS */, _hoisted_3))
            }), 128 /* KEYED_FRAGMENT */))
          ], 2 /* CLASS */)
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    (collections.value != null)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([_ctx.$style['items']])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(collections.value, (collection) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (__props.getVisible(collection))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (
                            collection.Settings?.combineFilteringWithParent ==
                            true
                        )
                      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(CheckboxItem, {
                            id: 'collectionCheckBox_' + collection.Id,
                            href: 
                                collection.Filler === true
                                    ? '#'
                                    : _unref(getCollectionUrl)(
                                          collection,
                                          __props.viewMode,
                                          __props.baseUrl,
                                          __props.value,
                                          __props.root ?? [],
                                          __props.matchedLogicalName,
                                          __props.matchedLogicalNameEntityGuid,
                                          __props.matchedLogicalNameModuleGuid,
                                          __props.matchedLogicalNameSubModuleGuid
                                      ) ?? '#'
                            ,
                            checked: 
                                isChecked(
                                    __props.value,
                                    collections.value.indexOf(collection),
                                    collection.Id
                                )
                            ,
                            name: getName(collection),
                            onSelect: ($event: any) => (
                                setChecked(
                                    collections.value.indexOf(collection),
                                    collection.Id,
                                    $event,
                                    undefined
                                )
                            )
                          }, null, 8 /* PROPS */, ["id", "href", "checked", "name", "onSelect"])
                        ], 512 /* NEED_PATCH */)), [
                          [_vShow, collection.Settings.invisibleOnFilters == false]
                        ])
                      : _withDirectives((_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass([_ctx.$style['main-item']])
                        }, [
                          _createElementVNode("a", {
                            onClick: _withModifiers(($event: any) => (
                                _ctx.$emit('navigate-to-collection', collection)
                            ), ["prevent"]),
                            href: 
                                collection.Filler === true
                                    ? '#'
                                    : _unref(getCollectionUrl)(
                                          collection,
                                          __props.viewMode,
                                          __props.baseUrl,
                                          __props.value,
                                          __props.root ?? [],
                                          __props.matchedLogicalName,
                                          __props.matchedLogicalNameEntityGuid,
                                          __props.matchedLogicalNameModuleGuid,
                                          __props.matchedLogicalNameSubModuleGuid
                                      ) ?? '#'
                            ,
                            class: _normalizeClass(_ctx.$style['link'])
                          }, [
                            (collection.Filler === true)
                              ? (_openBlock(), _createBlock(Filler, {
                                  key: 0,
                                  max: 15
                                }))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(collection.Name) + " ", 1 /* TEXT */),
                                  (_unref(debugProductCounts))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(collection.ProductCount), 1 /* TEXT */)
                                      ], 64 /* STABLE_FRAGMENT */))
                                    : _createCommentVNode("v-if", true)
                                ], 64 /* STABLE_FRAGMENT */))
                          ], 10 /* CLASS, PROPS */, _hoisted_6),
                          _createVNode(SubItems, {
                            collection: collection,
                            collections: collections.value,
                            items: 
                                getFlattenedCollectionsArrayWithCount(
                                    collection.SubCollections
                                )
                            ,
                            "parent-depth": getDepth(collection),
                            "set-checked": setChecked,
                            "is-checked": isChecked,
                            "debug-product-counts": _unref(debugProductCounts),
                            "view-mode": __props.viewMode,
                            "base-url": __props.baseUrl,
                            value: __props.value,
                            root: __props.root,
                            "matched-logical-name": __props.matchedLogicalName,
                            "matched-logical-name-entity-guid": 
                                __props.matchedLogicalNameEntityGuid
                            ,
                            "matched-logical-name-module-guid": 
                                __props.matchedLogicalNameModuleGuid
                            ,
                            "matched-logical-name-sub-module-guid": 
                                __props.matchedLogicalNameSubModuleGuid
                            
                          }, null, 8 /* PROPS */, ["collection", "collections", "items", "parent-depth", "debug-product-counts", "view-mode", "base-url", "value", "root", "matched-logical-name", "matched-logical-name-entity-guid", "matched-logical-name-module-guid", "matched-logical-name-sub-module-guid"])
                        ], 2 /* CLASS */)), [
                          [_vShow, 
                            collection.Settings == null ||
                            collection.Settings.invisibleOnFilters == false
                        ]
                        ])
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          }), 256 /* UNKEYED_FRAGMENT */))
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})